import { Pipe, PipeTransform } from '@angular/core';
import { AppConfig } from 'src/app/services/app.config.services';
import { getFormattedDateTime } from 'src/app/utils/timeManager';
@Pipe({ name: 'pendingTime' })
export class pendingTimePipe implements PipeTransform {
  appConfig = AppConfig;

  transform(value: any, ...args: unknown[]): unknown {
    //If the SentDateTime of the violation is in UTC then it has to be subtracted from the current UTC time
    const currentTime: Date = new Date(getFormattedDateTime(this.appConfig.settings.defaults.DateTimeSettings.SendInUTC));
    const escalatedTime: Date = new Date(value);
    const timeDiff: number = currentTime.getTime() - escalatedTime.getTime();
    let hours;
    let minutes;
    let seconds;
    Math.round(timeDiff / 3600000) > 9 ? hours = Math.round(timeDiff / 3600000) : hours = "0" + Math.round(timeDiff / 3600000);
    Math.round(timeDiff / (1000 * 60) % 60) > 9 ? minutes = Math.round(timeDiff / (1000 * 60) % 60) : minutes = "0" + Math.round(timeDiff / (1000 * 60) % 60);
    Math.round(timeDiff / (1000) % 60) > 9 ? seconds = Math.round(timeDiff / (1000) % 60) : seconds = "0" + Math.round(timeDiff / (1000) % 60);
    return `${hours}:${minutes}:${seconds}`;
  }
}
